export default __webpack_public_path__ + "images/V7.6bd08b1.png";